import {
    addItemToCollection,
    deleteItemFromCollection,
} from "directus/src/operations";

export async function removeTool(id) {
    try {
        const response = await deleteItemFromCollection("case_studies_tools", id);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

// export async function createTechStack({ item }) {
//     try {
//         const query = {
//             fields: [
//                 "id",
//                 "name",
//                 "type",
//                 "case_studies.case_study.id",
//             ],
//         };
//         const data = await addItemToCollection("tech_stack", item, query);
//         return data;
//     } catch (error) {
//         console.log(error);
//         throw error;
//     }
// }

export async function createTool({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "tool.id",
                "case_study.id",
            ],
        };
        const data = await addItemToCollection("case_studies_tools", item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}